import { selectDoc, event, selectAll } from "../utils/utils";

export class BlogPost {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.textContainer = selectDoc(".article-body");
    this.minutesContainer = selectDoc("[data-time-read]");
    this.iframe = selectDoc("iframe");
  }

  render() {
    this.calculateTimeRead();
    this.iframeResponsive();
  }

  calculateTimeRead = () => {
    const heightSection = this.textContainer.offsetHeight;
    const breakPoint = 250;
    const time =
      heightSection > breakPoint ? Math.ceil(heightSection / breakPoint) : 1;
    this.minutesContainer.innerHTML = `${time}`;
  };

  iframeResponsive = () => {
    function wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }

    const div = document.createElement("div");
    div.className = "iframe-responsive";

    if (this.iframe) {
      wrap(this.iframe, div);
    }
  };
}
